const SELECTOR = '.js-footer-video-item'

function ensureVideoPlayback(video) {
  if (!video) {
    return
  }
  video.muted = true
  video.playsInline = true
  video.autoplay = true

  const retryPlay = () => {
    video.play().catch(() => {})
  }

  video.play().catch(() => {
    video.addEventListener('loadeddata', retryPlay, { once: true })
    video.addEventListener('canplay', retryPlay, { once: true })
  })
}

// FooterVideo — CTA 背景動画の再生開始を制御
export default class FooterVideo {
  constructor() {
    this.video = null
    this.hasActivated = false
    this.observer = null
    this.init()
  }

  init() {
    this.video = document.querySelector(SELECTOR)
    if (!this.video) {
      return
    }

    const cta = document.querySelector('.c-cta-contact')
    if (cta && 'IntersectionObserver' in window) {
      this.observer = new IntersectionObserver(
        (entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) {
            return
          }
          this.activate()
          this.observer?.disconnect()
          this.observer = null
        },
        { rootMargin: '240px 0px' },
      )
      this.observer.observe(cta)
    } else {
      this.activate()
    }
  }

  activate() {
    if (this.hasActivated) {
      return
    }
    this.hasActivated = true
    ensureVideoPlayback(this.video)
  }

  destroy() {
    this.observer?.disconnect()
    this.observer = null
    this.video?.pause()
    this.video = null
    this.hasActivated = false
  }
}
